/**
 * MeetingSetupService
 * Service for MeetingSetup entity operations
 * Route: api/meetingsetups
 * Controller: MeetingSetupsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingSetupService
 * Handles meeting setup CRUD operations
 * Maps to /api/meetingsetups endpoint
 */
export class MeetingSetupService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingSetupService.DEFAULT_SERVICE_PATH,
            basePath: MeetingSetupService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingSetupService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingSetupService.BASE_PATH = 'api/meetingsetups';
//# sourceMappingURL=MeetingSetupService.js.map